<div
  class="classrooms-filter"
  [class.disabled]="disabled || loading || !hasClassrooms"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = !isOpen"
>
  <input type="text" [placeholder]="filterText" readonly />
  <span matSuffix class="material-icons arrow-icons" *ngIf="hasClassrooms && !isOpen">
    expand_more
  </span>
  <span matSuffix class="material-icons arrow-icons" *ngIf="isOpen">
    expand_less
  </span>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    (overlayOutsideClick)="isOpen = false"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayHasBackdrop]="true"
    (detach)="isOpen = false"
    (backdropClick)="isOpen = false"
  >
    <app-select-hierarquical-list
      *ngIf="segmentTreeData.length > 0"
      [treeData]="segmentTreeData"
      [initialSelection]="selectedIdsClassrooms"
      (selectEvent)="handleSelectClassroom($event)"
      class="custom-overlay"
    >
    </app-select-hierarquical-list>
  </ng-template>
</div>
